// extracted by mini-css-extract-plugin
export var dropdownButton = "_4i-0";
export var fullWidthDropdownButton = "_4i-1";
export var icon = "_4i-3";
export var iconPlaceholder = "_4i-2";
export var menuItemRow = "_4i-9";
export var separator = "_4i-e";
export var shortcutContainer = "_4i-7";
export var shortcutContainerFilled = "_4i-8";
export var shortcutIconLg = "_4i-6";
export var shortcutIconMd = "_4i-5";
export var shortcutIconSm = "_4i-4";
export var submenuChevron = "_4i-d";
export var submenuDropdown = "_4i-a";
export var submenuTriggerRow = "_4i-b";
export var submenuTriggerRowOpen = "_4i-c";